import axiosClient from "../axios";
import { ResultDataModel } from "../../utility/interface/api/result-data";
import { ResetBlobReq, ResetTokenBlobReq } from "../../utility/interface/auth";

export const loginViaId = (email: string, password: string) => {
  const url = `/auth/login`;
  const body = {
    email,
    password,
  };
  return axiosClient.post<ResultDataModel<any>>(url, body);
};

export const getRefreshToken = (resetTokenBlob: ResetTokenBlobReq) => {
  const url = `/auth/token/refresh`;
  const body = {
    ...resetTokenBlob,
  };

  return axiosClient.post<ResultDataModel<any>>(url, body);
};

export const resetPassword = (email: string) => {
  const url = `/auth/password/reset`;
  const body = {
    email: email,
  };
  return axiosClient.post<ResultDataModel<any>>(url, body);
};

export const confirmResetPassword = (resetBlob: ResetBlobReq) => {
  const url = `/auth/password/reset_confirm`;
  const body = {
    ...resetBlob,
  };
  return axiosClient.post<ResultDataModel<any>>(url, body);
};
